'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { MetaDefault, MonoSmall } from '../../../../components/typography';
import type { InlineToolDetailRow } from '../utils/inline-tool-details';

type TraceInlineArgsListProps = {
  rows: InlineToolDetailRow[];
};

const PROSE_MIN_WORDS = 4;

function isProseValue(value: string): boolean {
  const trimmed = value.trim();

  if (/^[[{<]/.test(trimmed) || /^https?:\/\//i.test(trimmed)) {
    return false;
  }

  return trimmed.split(/\s+/).length >= PROSE_MIN_WORDS;
}

export function TraceInlineArgsList({ rows }: TraceInlineArgsListProps) {
  if (rows.length === 0) {
    return null;
  }

  return (
    <VStack alignItems="stretch" gap={1}>
      {rows.map((row) => {
        const ValueTypography = isProseValue(row.value)
          ? MetaDefault
          : MonoSmall;

        return (
          <HStack key={row.key} gap={3} alignItems="baseline" minW={0}>
            <MetaDefault color="fg.subtle" flexShrink={0} minW="88px">
              {row.label}
            </MetaDefault>
            <ValueTypography
              color="fg.default"
              minW={0}
              whiteSpace="pre-wrap"
              wordBreak="break-word"
            >
              {row.value}
            </ValueTypography>
          </HStack>
        );
      })}
    </VStack>
  );
}
